(() => {
  const loader = document.getElementById('DelayedAppsLoader');
  if (!loader) return;
  const isProductPage = loader.dataset.productPage === 'true';

  const isChattyFont = (node) =>
    node?.tagName === 'LINK' &&
    /fonts\.bunny\.net/i.test(node.href || '') &&
    /family=Inter/i.test(node.href || '');

  if (isProductPage) {
    document.querySelectorAll('link[href*="fonts.bunny.net"]').forEach((link) => {
      if (isChattyFont(link)) link.remove();
    });

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (isChattyFont(node)) node.remove();
        });
      });
    }).observe(document.head, { childList: true });
  }

  const readDelay = (value, fallback) => {
    const delay = Number.parseInt(value || String(fallback), 10);
    return Number.isFinite(delay) ? delay : fallback;
  };

  const loadScript = (src, force = false) =>
    new Promise((resolve) => {
      const absoluteSource = new URL(src, document.baseURI).href;
      if (!force && Array.from(document.scripts).some((script) => script.src === absoluteSource)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = resolve;
      document.head.appendChild(script);
    });

  const syncCartDrawerState = () => {
    document.documentElement.classList.toggle(
      'll-cart-drawer-open',
      Boolean(document.querySelector('cart-drawer.active')),
    );
  };

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    syncCartDrawerState();
    new MutationObserver(syncCartDrawerState).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  let klaviyoObserver;
  const markKlaviyoWidgets = () => {
    const roots = new Set();

    document
      .querySelectorAll('[class*="klaviyo" i], [id*="klaviyo" i]')
      .forEach((element) => {
        if (element === document.body || element === document.documentElement) return;

        let root = element;
        while (root.parentElement && root.parentElement !== document.body) {
          root = root.parentElement;
        }
        if (root.parentElement === document.body) roots.add(root);

        let positioned = element;
        while (positioned && positioned !== document.body) {
          const style = getComputedStyle(positioned);
          const rect = positioned.getBoundingClientRect();
          if (
            style.position === 'fixed' &&
            rect.width > 0 &&
            rect.height > 0 &&
            rect.width <= 360 &&
            rect.height <= 360
          ) {
            positioned.dataset.llKlaviyoTeaser = 'true';
            positioned.dataset.llKlaviyoSide =
              rect.left <= window.innerWidth - rect.right ? 'left' : 'right';
            break;
          }
          positioned = positioned.parentElement;
        }
      });

    roots.forEach((root) => {
      root.dataset.llKlaviyoRoot = 'true';
    });
  };

  const watchKlaviyoWidgets = () => {
    markKlaviyoWidgets();
    if (klaviyoObserver) return;

    klaviyoObserver = new MutationObserver(markKlaviyoWidgets);
    klaviyoObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => klaviyoObserver?.disconnect(), 60000);
  };

  const runWhenIdle = (task) => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(task, { timeout: 1500 });
    } else {
      window.setTimeout(task, 0);
    }
  };

  const schedule = (delay, task) => {
    if (window.Shopify?.designMode) {
      runWhenIdle(task);
      return;
    }

    window.setTimeout(() => runWhenIdle(task), delay);
  };

  const loadChatty = () => {
    if (!loader.dataset.chattySrc) return;

    const released = window.__releaseChattyByTheme?.();
    if (released) {
      loadScript(loader.dataset.chattySrc, true);
    }
  };

  const loadGoogle = () => {
    if (!loader.dataset.googleSrc || !loader.dataset.googleMerchantId) return;

    loadScript(loader.dataset.googleSrc).then(() => {
      if (!window.merchantwidget?.start) return;

      window.merchantwidget.start({
        position: loader.dataset.googlePosition || 'RIGHT_BOTTOM',
        sideMargin: loader.dataset.googleSideMargin || '36',
        bottomMargin: loader.dataset.googleBottomMargin || '4',
        mobileSideMargin: loader.dataset.googleMobileSideMargin || '16',
        mobileBottomMargin: loader.dataset.googleMobileBottomMargin || '46',
        merchant_id: loader.dataset.googleMerchantId,
      });
    });
  };

  const loadKlaviyo = () => {
    if (loader.dataset.klaviyoSrc) {
      loadScript(loader.dataset.klaviyoSrc).then(watchKlaviyoWidgets);
    }
  };

  const scheduleApps = () => {
    schedule(readDelay(loader.dataset.chattyDelay, 3000), loadChatty);
    schedule(readDelay(loader.dataset.googleDelay, 6000), loadGoogle);
    schedule(readDelay(loader.dataset.klaviyoDelay, 10000), loadKlaviyo);
  };

  if (window.Shopify?.designMode) {
    scheduleApps();
    return;
  }

  let heroPaintConfirmed = false;
  const confirmHeroPaint = () => {
    if (heroPaintConfirmed) return;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (heroPaintConfirmed) return;
        heroPaintConfirmed = true;
        scheduleApps();
      });
    });
  };
  const heroImage = document.querySelector('.product__media img[fetchpriority="high"]');
  const confirmDecodedHeroPaint = () => {
    if (typeof heroImage?.decode !== 'function') {
      confirmHeroPaint();
      return;
    }

    heroImage.decode().then(confirmHeroPaint).catch(confirmHeroPaint);
  };

  if (heroImage?.complete && heroImage.naturalWidth > 0) {
    confirmDecodedHeroPaint();
  } else if (heroImage) {
    heroImage.addEventListener('load', confirmDecodedHeroPaint, { once: true });
    heroImage.addEventListener('error', confirmHeroPaint, { once: true });
  } else if (document.readyState === 'complete') {
    confirmHeroPaint();
  } else {
    window.addEventListener('load', confirmHeroPaint, { once: true });
  }

  // Broken extensions or unusual media must not suppress essential storefront
  // integrations forever. This fallback is deliberately later than the
  // slowest measured product LCP.
  window.setTimeout(confirmHeroPaint, 15000);
})();
